import { render, staticRenderFns } from "./TaskSideBar.vue?vue&type=template&id=96b70f1e&"
import script from "./TaskSideBar.vue?vue&type=script&lang=js&"
export * from "./TaskSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports